<template>
  <van-empty image="/images/empty-image-default.png"
    :description="message || $t('暂无数据')" style="padding: 0;"/>
</template>

<script>
import { Empty as VanEmpty } from 'vant'

export default {
  name: 'empty',
  components: {
    VanEmpty
  },
  props: {
    message: String
  }
}
</script>
